import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal'
import { Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { URLFailedListResponse } from '../../interfaces'

interface Props {
  data: URLFailedListResponse[] | undefined
  isOpen: boolean
  onClose(): void
}

const RejectedURLModal = ({
  data,
  isOpen,
  onClose,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t('list_of_rejected_urls', "List of rejected URL's")}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Table marginTop="1em">
            <Thead>
              <Tr>
                <Th>{t('url', 'URL')}</Th>
                <Th>{t('reason', 'Reason')}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data?.map((x, id) => (
                <Tr key={id}>
                  <Td>{x.url}</Td>
                  <Td>{x.message}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default RejectedURLModal
